import React, { useContext, useEffect } from 'react';
import {
   Nav, Tab,
} from 'react-bootstrap';

import { NavItem, NavLink, TabsWrap } from '@/shared/components/Tabs';
import Search from './Search';
import { Mealcontext } from '../../../../context/MealContext';
import MealDetails from './MealDetails';

const Tabs = () => {
  const { 
    isDetailsClick, 
    click, 
    setclick,
    activeKey, 
    setActiveKey,
  } = useContext(Mealcontext);

  useEffect(() => {
    if (isDetailsClick) {
      setActiveKey('2');
      setclick('detailsClick');
    }
  }, [isDetailsClick]);

  return (
    <Tab.Container activeKey={activeKey} onSelect={key => setActiveKey(key)}>
      <TabsWrap>
        <Nav className="nav-tabs">
          <NavItem>
            <NavLink eventKey="1" disabled={isDetailsClick}>Search</NavLink>
          </NavItem>
          <NavItem>
            <NavLink eventKey="2" disabled={!isDetailsClick}>Details</NavLink>
          </NavItem>
            
        </Nav>
        <Tab.Content>
          <Tab.Pane eventKey="1">
            {click === 'searchSelect' && <Search />}
          </Tab.Pane>
          <Tab.Pane eventKey="2">
            {click === 'detailsClick' && <MealDetails setActiveKey={setActiveKey} />}
          </Tab.Pane>
        </Tab.Content>
      </TabsWrap>
    </Tab.Container>
  );
};

export default Tabs;
